export default __webpack_public_path__ + "static/media/12.c4e14b25.jpg";